import { Component, ViewChildren, QueryList, OnInit } from "@angular/core";
import {
  Platform,
  IonRouterOutlet,
  AlertController,
  ModalController,
  ToastController,
  NavController,
} from "@ionic/angular";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { AppVersion } from "@awesome-cordova-plugins/app-version/ngx";
import { Network } from "@awesome-cordova-plugins/network/ngx";
import { TranslateService } from "@ngx-translate/core";

import { Router } from "@angular/router";
import { Events } from "./provider/events.service";
import { AuthService } from "./services/auth.service";
import { ApiService } from "./provider/api.service";
import { ConfigService } from "./provider/config.service";
import { endpoints } from "./constant/endpoints";
import { register } from "swiper/element/bundle";
register();
import * as moment from "moment";
import { DataService } from "./services/data.service";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {
  @ViewChildren(IonRouterOutlet)
  routerOutlets: QueryList<IonRouterOutlet>;
  APP_VERSION = "1.0.0";
  settings: any = {};
  backButton = true;
  connectedToInternet: boolean = true;
  lastTimeBackPress = 0;
  timePeriodToExit = 4000;
  splash = false;

  today = moment().format("YYYY-MM-DD");
  colorprimary: any;
  colorsecondary: any;
  colortertiary: any;
  p2: any;
  s2: any;
  t2: any;
  p3: any;
  s3: any;
  t3: any;
  p4: any;
  s4: any;
  t4: any;
  shadowlight: any;
  shadowdark: any;
  shadowcolorlight: any;
  shadowcolordark: any;
  bglight: any;
  bgdark: any;
  highlight: any;
  highdark: any;
  diffuselight: any;
  diffusedark: any;
  diffuselightselected: any;
  diffusedarkselected: any;
  colorlight: any;
  colordark: any;
  colorback: any;
  colorbackdark: any;
  greenmacro: any;
  redmacro: any;
  yellowmacro: any;
  shadowhighlight: any;
  shadowhighdark: any;
  lowNutrition: any;
  highNutrition: any;
  avgNutrition: any;
  carbcolor: any;
  caloriecolor: any;
  protcolor: any;
  fatcolor: any;

  protcolorlight: string;
  fatcolorlight: string;
  carbcolorlight: string;
  caloriecolorlight: string;
  weekMenuData: any[];
  customer: any;
  daysafter: number;
  slideback: string;
  colortertiarymain: string;
  colorsecondarymain: string;
  colorprimarymain: string;
  // colors = {
  //     primary_container: '#d2a787',
  //     secondary_container: '#DFA878',
  //     tertiary_container: '#6C3428',
  //     on_primary_container: '#d2a787',
  //     on_secondary_container: '#DFA878',
  //     on_tertiary_container: '#6C3428'
  // };
  colors = {
    primary: "#35858b",
    secondary: "#4fbdba",
    tertiary: "#082227",
    on_primary: "#35858b",
    on_secondary: "#4fbdba",
    on_tertiary: "#082227",
  };
  darkermain = {
    h: 0, // Hue in degrees (0 to 360)
    s: 5, // Saturation in percentage (0 to 100)
    l: 5, // Lightness in percentage (0 to 100)
  };
  lightermain = {
    h: 0, // Hue in degrees (0 to 360)
    s: 0, // Saturation in percentage (0 to 100)
    l: 95, // Lightness in percentage (0 to 100)
  };
  white: string;
  black: string;
  light: any;
  dark: any;
  lightgrey: string;
  darkgrey: string;
  darker: string;
  grey: string;
  greyhalf: string;
  greymore: string;
  greyless: string;
  darklightgrey: string;
  darkdarkgrey: string;
  darkdarker: string;
  darkgreyhalf: string;
  darkgreymore: string;
  darkgreyless: string;
  banners: string[] = []; // Store multiple banners
  currentBannerIndex = 0; // To track the current banner index
  bannerSwitchInterval: any;
  invertPrime: string;
  invertSecond: string;
  invertTri: string;
  dtextprimary: string;
  dtextsecond: string;
  dtexttri: string;

  serverVersion: any = 0;
  splittedVersion: any;
  androidURL = "https://play.google.com/store/apps/details?id=com.dietmaster1";
  iosURL = "https://apps.apple.com/us/app/dietmaster/id1600484121";
  appPayload: any;
  days: any;
  diffusecolorselected: string;
  diffusecolor: string;
  colorprimarylighter: string;
  colorsecondarylighter: string;
  colortertiarylighter: string;
  colorprimarydeeper: string;
  colorsecondarydeeper: string;
  colortertiarydeeper: string;
  fixtest: {
    h: any; s: any; // Ensure saturation is between 3-100%
    l: any; // Ensure lightness is between 3-100%
  };
  q1: any;
  q2: any;
  q3: any;
  q4: any;

  constructor(
    private router: Router,
    private dataservice: DataService,
    private platform: Platform,
    private events: Events,
    private network: Network,
    private inAppBrowser: InAppBrowser,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private screenOrientation: ScreenOrientation,
    private authService: AuthService,
    private configService: ConfigService,
    private apiService: ApiService,
  ) {}

  async initializeApp() {
    
    await this.loadBackgroundData();
    

    
    const customer = await this.authService.getAuthUser();

    if (customer) {
      await this.dataservice.getMySubscription(customer.id);
      this.days = await this.dataservice.getDaysData();
    }

    setTimeout(async () => {
      let splashScreen = (document.getElementById(
        'SplashScreen'
      ).style.display = 'none');
      console.log(splashScreen, 'splash');
      // this.allmenu()
    }, 500);
  }

  async ngOnInit() {
    this.initializeApp();
  }
  async ionViewWillEnter() {
    // await this.allmenu()
  }
  async loadBackgroundData() {
    this.configService.getAppSettings().then((settingData: any) => {
      this.settings = JSON.parse(settingData);
      //alert(this.settings.appLanguage);
      this.translate.setDefaultLang(this.settings.appLanguage);
      this.translate.use(this.settings.appLanguage);
      this.appUser(this.settings.currentUser);
      if (this.platform.is("capacitor")) {
        this.screenOrientation.lock(
          this.screenOrientation.ORIENTATIONS.PORTRAIT,
        );
        this.checkNetworkConnection();
      }
      // document.body.classList.toggle("dark", this.settings.appDarkMode);
      this.events.publish("DarkMode:change", { darkMode: true });
    });
    this.apiService.get(endpoints.configuration).subscribe(async (response) => {
      if (response.success) {
        this.daysafter = response?.settings?.menu_selection_before
          ? Number(response?.settings?.menu_selection_before)
          : 0;
        const htmlEl = document.querySelector('html');
        if (response.data?.quote) {
          this.configService.setStorage('appQuote', response.data.quote);
        }
        // console.log(response.data.organization.configurations, 'shakir');
        this.colors.primary =
          response.data.organization.configurations.theme.primary;
        this.colors.secondary =
          response.data.organization.configurations.theme.secondary;
        this.colors.tertiary =
          response.data.organization.configurations.theme.tertiary;
        this.colors.on_primary =
          response.data.organization.configurations.theme.on_primary;
        this.colors.on_secondary =
          response.data.organization.configurations.theme.on_secondary;
        this.colors.on_tertiary =
          response.data.organization.configurations.theme.on_tertiary;
          this.lowNutrition = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.settings
                .low_nutrition_highlight
            )
          );
          this.avgNutrition = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.settings
                .average_nutrition_highlight
            )
          );
          this.highNutrition = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.settings
                .high_nutrition_highlight
            )
          );
  
          this.caloriecolor = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme.on_primary_container
            )
          );
          this.protcolor = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme
                .on_secondary_container
            )
          );
          this.carbcolor = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme
                .on_tertiary_container
            )
          );
          this.fatcolor = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme.on_error_container
            )
          );
  
          this.caloriecolorlight = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme.on_primary_container
            )
          );
          this.protcolorlight = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme
                .on_secondary_container
            )
          );
          this.carbcolorlight = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme
                .on_tertiary_container
            )
          );
          this.fatcolorlight = this.finalHSL(
            this.hexToHsl(
              response.data.organization.configurations.theme.on_error_container
            )
          );
  
      this.p2 = this.finalHSL(this.hexToHsl(response.data.organization.configurations.theme.primary));
          this.s2 = this.finalHSL(this.hexToHsl(response.data.organization.configurations.theme.secondary));
          this.t2 = this.finalHSL(this.hexToHsl(response.data.organization.configurations.theme.tertiary));
  
       this.shadowlight = this.hslShadowLight(this.hexToHsl(this.colors.primary));

       htmlEl.style.setProperty("--kcal", this.caloriecolor);
       htmlEl.style.setProperty("--prot", this.protcolor);
       htmlEl.style.setProperty("--carb", this.carbcolor);
       htmlEl.style.setProperty("--fat", this.fatcolor);

       htmlEl.style.setProperty("--kcal-light", this.caloriecolorlight);
       htmlEl.style.setProperty("--prot-light", this.protcolorlight);
       htmlEl.style.setProperty("--carb-light", this.carbcolorlight);
       htmlEl.style.setProperty("--fat-light", this.fatcolorlight);

       htmlEl.style.setProperty("--p2", this.p2);
       htmlEl.style.setProperty("--s2", this.s2);
       htmlEl.style.setProperty("--t2", this.t2);

       htmlEl.style.setProperty("--low-nutri", this.lowNutrition);
       htmlEl.style.setProperty("--avg-nutri", this.avgNutrition);
       htmlEl.style.setProperty("--high-nutri", this.highNutrition);
       htmlEl.style.setProperty("--shadow-light", this.shadowlight);


        this.theColorUpdate(response.data.organization.configurations.theme.primary,response.data.organization.configurations.theme.secondary,response.data.organization.configurations.theme.tertiary);

        console.log(response);
        this.configService.setStorage('appPayload', response.data.organization);
        // this.appPayload = await this.configService.getStorage('appPayload');
        this.events.publish('payload:configuration', {
          appPayload: response.data.organization,
          time: new Date(),
        });
        const isDarkMode = this.settings.appDarkMode;

        console.log(this.settings);
        // await this.checkLatestVersion(response.data.organization.force_update);
        // this.backButtonEvent();
      }
    });

    this.events.subscribe("language:change", (data: any) => {
      console.log(data);
      setTimeout(() => {
        window.location.reload();
      }, 5);
    });

    this.events.subscribe("DarkMode:change", (data: any) => {
      console.log(data);
      // this.theColorUpdate(this.colors.on_primary,this.colors.on_secondary,this.colors.on_tertiary);
      // this.theColorUpdate(response.data.organization.configurations.theme.primary,response.data.organization.configurations.theme.secondary,response.data.organization.configurations.theme.tertiary);
    });

    this.events.subscribe("user:login", (data: any) => {
      // const customer = this.authService.getAuthUser();
      // if (customer){
      // this.dataservice.getMySubscription(customer.id);
      // this.dataservice.getDaysData()
      // this.dataservice.getDayConfigData()
      // }
      // console.log(customer);
      console.log(data.user);
      if (data.user == null) {
        this.configService.getAppSettings().then(async (settingData: any) => {
          this.settings = JSON.parse(settingData);
          console.log(this.settings);
          this.settings.currentUser = null;
          this.configService.setStorage("appSettings", this.settings);

          try {
            const element = await this.modalCtrl.getTop();
            if (element) {
              element.dismiss();
              return;
            }
          } catch (error) {
            console.log(error);
          }
          this.authService.setAuthUser(null);
          this.authService.logOutUser();
          this.navCtrl.navigateRoot(["/onboarding"]);
        });
      }
      {
      }
    });
    // this.events.subscribe('app:update', (data: any) => {
    // 	const customer = this.authService.getAuthUser();
    // 	console.log(customer);
    // 	if (data.user == null) {
    // 		this.configService.getAppSettings()
    // 			.then(async (settingData: any) => {
    // 				this.settings = JSON.parse(settingData);
    // 				console.log(this.settings);
    // 				this.settings.currentUser = null;
    // 				this.configService.setStorage('appSettings', this.settings);
    // 				this.authService.setAuthUser(null);
    // 				this.authService.logOutUser();
    // 				this.navCtrl.navigateRoot(['/force-update']);
    // 			}
    // 			);
    // 	}
    // });

    // }, 1000);
    // });
  }

  // allmenu = async () => {
  //   try {
  //     // Ensure `getDaysData` is an array and iterate over it
  //     //   const days = this.dataservice.getDaysData;

  //     if (!Array.isArray(this.days) || this.days.length === 0) {
  //       throw new Error('No this.days available in getthis.daysData');
  //     }

  //     // Map over the this.days and call loadData for each, collecting promises
  //     const promises = this.days.map((day) =>
  //       this.dataservice.fetchDataForDate(
  //         moment(day).format('YYYY-MM-DD'),
  //         'false'
  //       )
  //     );

  //     // Wait for all the promises to resolve
  //     const results = await Promise.all(promises);

  //     console.log('All menu data loaded:', results);
  //   } catch (error) {
  //     console.error('Error loading menu data:', error);
  //   }
  // };
  checkLatestVersion = async (appData: any) => {
    const versionNumbner = this.APP_VERSION; //await this.appVersion.getVersionNumber();
    if (this.platform.is("android")) {
      const androidResponse = appData.android;
      this.androidURL = androidResponse.application_url;
      this.serverVersion = androidResponse.latest_version.split(".");
      this.splittedVersion = versionNumbner.split(".");
      //alert(this.serverVersion[0] +' - '+ this.splittedVersion[0] + ' - '+androidResponse.enabled);
      if (androidResponse.enabled) {
        this.backButton = false;
        this.appUpdate(appData.alerts.title, appData.alerts.description);
      } else if (this.serverVersion[0] > this.splittedVersion[0]) {
        //major changes
        this.backButton = false;
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
        );
        this.events.publish("app:update", { user: null, time: new Date() });
      } else if (this.serverVersion[1] > this.splittedVersion[1]) {
        //minor changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.minor.description,
          appData.alerts.button_text,
          true,
        );
      } else if (this.serverVersion[2] > this.splittedVersion[2]) {
        //optional changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
          true,
        );
      }
    } else if (this.platform.is("ios")) {
      const iosResponse = appData.ios;
      //alert(versionNumbner);
      //alert(iosResponse.latest_version);
      this.iosURL = iosResponse.url;
      this.serverVersion = iosResponse.latest_version.split(".");
      this.splittedVersion = versionNumbner.split(".");
      if (iosResponse.enabled) {
        this.backButton = false;
        this.appUpdate(appData.alerts.title, appData.alerts.description);
      } else if (this.serverVersion[0] > this.splittedVersion[0]) {
        //major changes
        this.backButton = false;
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
        );
        this.events.publish("app:update", { user: null, time: new Date() });
      } else if (this.serverVersion[1] > this.splittedVersion[1]) {
        //minor changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
          true,
        );
      } else if (this.serverVersion[2] > this.splittedVersion[2]) {
        //optional changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
          true,
        );
      }
    }
  };
  hslFixAdjustPercent(hsl: { h: number; s: number; l: number },fh?,fs?,fl?,ah?,as?,al?,ph?,ps?,pl?,alpha?){
    // h is hue - s is saturation - l is lightness
    //f (hsl) - fixed input values - the fh will replace the original value
    //a (hsl) - adjusted input values - the ah will be added to the existing h value.
    //p (hsl) - percentage input values -  the ph will be the percentage of original value and added to it, so -20 is 20% decrease
    const hParams = [fh, ah, ph];
    const sParams = [fs, as, ps];
    const lParams = [fl, al, pl];
    const maincolor = hsl;
    if (alpha == null || alpha == undefined){
      alpha = 1
    }
    // Check for duplicate values in each group (h, s, l)
    const isUnique = (params: (number | undefined)[]) => {
      const filtered = params.filter(param => param !== undefined);
      const nume = new Set(filtered).size ;
      if ((new Set(filtered).size) > 1){
        return false
      } else {
        return true
      }
      // return true
    };
    // console.log(isUnique(hParams),isUnique(sParams),isUnique(lParams),'uniqueness')
    // console.log(isUnique(hParams) && isUnique(sParams) && isUnique(lParams),'validate')

    if (isUnique(hParams)) {
      hsl.h = ph ? Math.max(3, Math.min(100, maincolor.h + (maincolor.h * ph) / 100)) : maincolor.h
      hsl.h = ah ? Math.max(3, Math.min(100, maincolor.h + ah)) : maincolor.h
      hsl.h = fh ? fh : maincolor.h
      

    }else {
      hsl.h = maincolor.h
    }
    if (isUnique(sParams)) {
      hsl.s = ps ? Math.max(3, Math.min(100, maincolor.s + (maincolor.s * ps) / 100)) : maincolor.s
      hsl.s = as ? Math.max(3, Math.min(100, maincolor.s + as)) : maincolor.s
      hsl.s = fs ? fs : maincolor.s
      

    }else {
      hsl.s = maincolor.s
    }
    if (isUnique(lParams)) {
      hsl.l = pl ? Math.max(3, Math.min(100, maincolor.l + (maincolor.l * pl) / 100)) : maincolor.l
      hsl.l = al ? Math.max(3, Math.min(100, maincolor.l + al)) : maincolor.l
      hsl.l = fl ? fl : maincolor.l
      

    }else {
      hsl.l = maincolor.l
    }

    // return {h:hsl.h,s:hsl.s,l:hsl.l,alpha}
    return { ...hsl, h:hsl.h,s:hsl.s,l:hsl.l,alpha };

  }
  // finalHSL(hsl?: Partial<{ h: number; s: number; l: number; alpha: number }>): string {
  //   const safeHSL = {
  //     h: hsl?.h,
  //     s: hsl.s,
  //     l: hsl.l,
  //     alpha: hsl?.alpha ?? 1,
  //   };
    
  //   return `hsl(${safeHSL.h}deg ${safeHSL.s}% ${safeHSL.l}% / ${safeHSL.alpha})`;
  // }
  finalHSL(hsl:{h,s,l,alpha?}) {
    const safeHSL = {
      h: hsl.h,
      s: hsl.s,
      l: hsl.l,
      alpha: hsl?.alpha ?? 1,
    };
    
    return `hsl(${safeHSL.h}deg ${safeHSL.s}% ${safeHSL.l}% / ${safeHSL.alpha})`;
  }

  openAppstoreEntry = async () => {
    if (this.platform.is("android")) {
      this.inAppBrowser.create(this.androidURL, "_blank");
      // NativeMarket.openStoreListing({
      //     appId: await this.appVersion.getPackageName().then(packageName => {return packageName;})
      // });
    } else if (this.platform.is("ios")) {
      this.inAppBrowser.create(this.iosURL, "_blank");
    }
  };
  appUpdate = async (header, message, buttonText = "", allowcloss = false) => {
    const buttons = [];
    if (buttonText != "") {
      buttons.push({
        text: buttonText,
        handler: () => {
          this.openAppstoreEntry();
        },
      });
    }
    if (allowcloss) {
      buttons.push({
        text: "Close",
        role: "Cancel",
      });
    }
    await this.alertCtrl
      .create({
        header,
        message,
        buttons,
        mode: "ios",
        backdropDismiss: allowcloss,
      })
      .then((alertElem) => alertElem.present());
  };
  appUser = async (currentUser: any) => {
    console.log(currentUser);

    if (
      currentUser &&
      currentUser != null &&
      window.localStorage.getItem("auth-token") != "null" &&
      window.localStorage.getItem("auth-token") != null
    ) {
      // await this.dataservice.getMySubscription(currentUser.id);
      // const customer = this.authService.getAuthUser();
      // if (customer){
      // this.dataservice.getMySubscription(customer.id);
      // this.dataservice.getDaysData()
      // this.dataservice.getDayConfigData()
      // }
    } else {
      window.localStorage.setItem("auth-token", null);
    }
  };
  backButtonEvent = () => {
    if (this.backButton) {
      this.platform.backButton.subscribeWithPriority(10, async () => {
        //try { const element = await this.alertCtrl.getTop(); if (element) { element.dismiss(); return; } } catch (error) { console.log(error); }
        try {
          const element = await this.modalCtrl.getTop();
          if (element) {
            element.dismiss();
            return;
          }
        } catch (error) {
          console.log(error);
        }
        this.routerOutlets.forEach(async (outlet: IonRouterOutlet) => {
          //alert(this.router.url);
          if (outlet && outlet.canGoBack()) {
            outlet.pop();
          } else if (
            this.router.url === "/" ||
            this.router.url === "/login" ||
            this.router.url === "/signin" ||
            this.router.url === "/tabs/menu" ||
            this.router.url === "/tabs/calendar" ||
            this.router.url === "/tabs/notifications" ||
            this.router.url === "/tabs/accounts" ||
            this.router.url === "/tabs/order"
          ) {
            if (
              new Date().getTime() - this.lastTimeBackPress <
              this.timePeriodToExit
            ) {
              await this.showConfirm();
            } else {
              await this.toastCtrl
                .create({
                  message: this.translate.instant(
                    "press_back_again_to_exit_app",
                  ),
                  duration: 4000,
                  position: "top",
                  color: "light",
                })
                .then((toastElem) => toastElem.present());
            }
            this.lastTimeBackPress = new Date().getTime();
          }
          // else if(this.router.url === '/subscription-list?historyRoute=login&landingPage=signup')
          // {
          //     alert('MD');
          // }
        });
      });
    }
  };
  checkNetworkConnection = () => {
    this.network.onDisconnect().subscribe(() => {
      this.connectedToInternet = false;
      this.translate
        .get(["Please Connect to the Internet!", "Disconnected"])
        .subscribe(async (res) => {
          let alertMsg = await this.alertCtrl.create({
            header: this.translate.instant("no_internet"),
            message: this.translate.instant("please_connect_to_the_internet"),
            mode: "ios",
            buttons: [
              {
                text: this.translate.instant("ok"),
                handler: () => {
                  navigator["app"].exitApp();
                },
              },
            ],
          });
          alertMsg.present();
        });
    });
    this.network.onConnect().subscribe(() => {
      if (!this.connectedToInternet) {
        window.location.reload();
        const customer = this.authService.getAuthUser();
        if (customer) {
          // this.dataservice.getMySubscription(customer.id);
          // this.dataservice.getDaysData()
          // this.dataservice.getDayConfigData()
        }
        this.translate
          .get(["Network connected Reloading Data", "Connected"])
          .subscribe(async (res) => {
            let alertMsg = await this.alertCtrl.create({
              header: this.translate.instant("network_found"),
              message: this.translate.instant(
                "network_connected_reloading_data",
              ),
              mode: "ios",
              buttons: [{ text: this.translate.instant("ok") }],
            });
            alertMsg.present();
          });
      }
    });
  };
  showConfirm = async () => {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant("confirm"),
      message: this.translate.instant("are_you_sure_you_want_to_exit_the_app"),
      buttons: [
        {
          text: this.translate.instant("cancel"),
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: this.translate.instant("close_app"),
          handler: () => {
            navigator["app"].exitApp();
          },
        },
      ],
      //enterAnimation: customAlertEnter
    });
    await alert.present();
  };

  hexToHsl(hex:any) {
    hex = hex.replace(/^#/, '');

    let r = 0,
      g = 0,
      b = 0;

    // Check for shorthand hex (e.g., #abc) and expand it
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
      // Full hex (e.g., #aabbcc)
      r = parseInt(hex.slice(0, 2), 16);
      g = parseInt(hex.slice(2, 4), 16);
      b = parseInt(hex.slice(4, 6), 16);
    } else {
      throw new Error('Invalid HEX color format');
    }

    // Convert RGB values to a range of 0 to 1
    r /= 255;
    g /= 255;
    b /= 255;

    // Find the max and min values of RGB
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    // Calculate Lightness
    let l = (max + min) / 2;

    let h = 0,
      s = 0;

    if (delta !== 0) {
      // Calculate Hue and Saturation only if there's no gray (delta = 0)
      // Saturation
      s = delta / (1 - Math.abs(2 * l - 1));

      // Hue
      if (max === r) {
        h = ((g - b) / delta + (g < b ? 6 : 0)) % 6;
      } else if (max === g) {
        h = (b - r) / delta + 2;
      } else if (max === b) {
        h = (r - g) / delta + 4;
      }

      h *= 60; // Convert to degrees
    }

    // Convert to percentages
    h = Math.round(h);
    s = Math.round(s * 100);
    l = Math.round(l * 100);

    return {h, s, l };
  }
  // hexDhsl(hsl:{h, s, l,alpha? }){}
  hslShadowLight(hsl) {
    let newl = 5;
    return `${hsl.h}deg ${hsl.s}% ${newl}%`;
  }
  invertHsl(hsl) {
    let h = (hsl.h + 180) % 360;
    let l = hsl.l < 50 ? hsl.l + 30 : hsl.l - 30;
    return {h:h,s:hsl.s,l:l,alpha:1};
  }

  dynamicText(hsl) {
    let l = hsl.l <= 51 ? 100 : 0;
    console.log(l, hsl.l, 'l and hsl.l');
    const safeHSL = {
      h: 0,
      s: 0,
      l: l,
      alpha: hsl?.alpha ?? 1,
    };
    return safeHSL;
  }
  setColorVariables(htmlEl: HTMLElement, prefix: string, baseHSL: any, shades: any) {
    Object.keys(shades).forEach((shade) => {
      htmlEl.style.setProperty(`--ion-${shade}-${prefix}`, this.finalHSL(shades[shade]({...baseHSL})));
    });
  }

  theColorUpdate(primary,secondary,tertiary){

    const htmlEl = document.documentElement; // Get the root HTML element
    if (!htmlEl) return;
  
    const primaryHSL = this.hexToHsl(primary);
    // console.log('this is primary',primary,':',primaryHSL)
    const secondaryHSL = this.hexToHsl(secondary);
    const tertiaryHSL = this.hexToHsl(tertiary);
    const greyHSL = this.hexToHsl('#c1c1c1');

    let shades = {
      color: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,1),

      dark: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined, -20, -30,undefined,undefined,undefined,1),
      light: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined, 20, 30,undefined,undefined,undefined,1),

      black: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,3,undefined,undefined,undefined,undefined,undefined,undefined,1),
      white: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,98,undefined,undefined,undefined,undefined,undefined,undefined,1),

      gold: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined, 10, 10,undefined,undefined,undefined,1),

      pastel: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined, -10, -10,undefined,undefined,undefined,1),

      dim: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined, -15, -20,undefined,undefined,undefined,1),

      cool: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined, 5, -5,undefined,undefined,undefined,1),

      neutral: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined, -5, 5,undefined,undefined,undefined,1),

      shadowdark: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,10,undefined,undefined,undefined,undefined,undefined,1),
      shadowlight: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,5,undefined,undefined,undefined,undefined,undefined,1),

      shadowcolorlight: (hsl) => this.hslFixAdjustPercent(hsl, -30, -20,undefined,undefined,undefined,undefined,undefined,undefined,1),
      shadowcolordark: (hsl) => this.hslFixAdjustPercent(hsl, 10, -50,undefined,undefined,undefined,undefined,undefined,undefined,1),

      bglight: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,97,undefined,undefined,undefined,undefined,10,undefined,1),
      bgdark: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,3,undefined,undefined,undefined,undefined,50,undefined,1),

      lighter: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,25,1),
      deeper: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,-25,1),

      highlight: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,25,1),

      diffusedark: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,5,undefined,undefined,undefined,undefined,-70,undefined,0.5),
      diffuselight: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,90,undefined,undefined,undefined,undefined,20,undefined,0.2),

      diffusedarker: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,3,undefined,undefined,undefined,undefined,-70,undefined,0.7),
      diffuselighter: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,95,undefined,undefined,undefined,undefined,20,undefined,0.1),

      diffusecolor: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,0.3),
      diffusecolored: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,0.7),

      text: (hsl) => this.dynamicText(hsl),
      invert: (hsl) => this.invertHsl(hsl),

      clear: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,0.2),
      fade: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,0.1),

    }
    let greys = {
      color: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,1),

      dark: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined, -20, -30,undefined,undefined,undefined,1),
      light: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined, 20, 30,undefined,undefined,undefined,1),

      black: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined,undefined,3,undefined,undefined,undefined,1),
      white: (hsl) => this.hslFixAdjustPercent(hsl,undefined,undefined,undefined,undefined,undefined,98,undefined,undefined,undefined,1),

      less: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,0.3),
      half: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,0.5),
      more: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,0.7),

      clear: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,0.2),
      fade: (hsl) => this.hslFixAdjustPercent(hsl, undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,0.1),

    };


// console.log("dl-prime:", shades.diffuselight(primaryHSL));
// console.log("dliter-prime:", shades.diffuselighter(primaryHSL));
// console.log("ddark-prime:", shades.diffusedark(primaryHSL));
// console.log("ddarker-prime:", shades.diffusedarker(primaryHSL));

// console.log("dl-secondary:", shades.diffuselight(secondaryHSL));
// console.log("dliter-secondary:", shades.diffuselighter(secondaryHSL));
// console.log("ddark-secondary:", shades.diffusedark(secondaryHSL));
// console.log("ddarker-secondary:", shades.diffusedarker(secondaryHSL));

// console.log("dl-tertiary:", shades.diffuselight(tertiaryHSL));
// console.log("dliter-tertiary:", shades.diffuselighter(tertiaryHSL));
// console.log("ddark-tertiary:", shades.diffusedark(tertiaryHSL));
// console.log("ddarker-tertiary:", shades.diffusedarker(tertiaryHSL));

// console.log("primary:", shades.color(primaryHSL));
// console.log("secondary:", shades.color(secondaryHSL));
// console.log("tertiary:", shades.color(tertiaryHSL));
// console.log("grey:", greys.color(greyHSL));
// console.log(primaryHSL,'pshl')

    this.setColorVariables(htmlEl, 'primary', { ...primaryHSL }, shades);
    this.setColorVariables(htmlEl, 'secondary', { ...secondaryHSL }, shades);
    this.setColorVariables(htmlEl, 'tertiary', { ...tertiaryHSL }, shades);
    this.setColorVariables(htmlEl, 'grey', { ...greyHSL }, greys);


  }
  // adjustHSL(hsl: any, ...args: any[]) {
  //   return this.hslFixAdjustPercent(hsl, ...args);
  // };

}
